import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FiEye, FiDownload, FiPackage } from 'react-icons/fi';
import { ordersAPI } from '../services/api';
import Loading from '../components/Loading';

const statusClassMap = {
  'Order Placed': 'order-placed',
  'Order Received': 'order-received',
  'Under Manufacturing': 'under-manufacturing',
  'Packed': 'packed',
  'Ready for Dispatch': 'ready-for-dispatch',
  'Dispatched': 'dispatched',
  'Delivered': 'delivered',
  'Cancelled': 'cancelled',
};

const paymentChipClass = (status) => {
  if (status === 'Paid') return 'paid';
  if (status === 'Failed') return 'failed';
  return 'pending';
};

const OrdersPage = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const { data } = await ordersAPI.getMyOrders();
        if (data.success) {
          setOrders(data.orders);
        }
      } catch (error) {
        console.error('Error fetching orders:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchOrders();
  }, []);

  if (loading) return <Loading message="Loading your orders..." />;

  if (orders.length === 0) {
    return (
      <div className="page container">
        <div className="empty-state">
          <div className="emoji">📦</div>
          <h3>No orders yet</h3>
          <p>Browse our pickle collection and place your first order!</p>
          <Link to="/" className="btn btn-primary" style={{ width: 'auto', marginTop: 20 }}>
            🥒 Browse Pickles
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="page container" style={{ maxWidth: 820, margin: '0 auto' }}>
      <div className="page-header">
        <h2 style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <FiPackage style={{ color: 'var(--primary)' }} /> My Orders
        </h2>
      </div>

      {orders.map((order) => (
        <div key={order._id} className="order-card">
          <div className="order-card-header">
            <div>
              <div className="order-number">{order.orderNumber}</div>
              <div className="order-date">
                {new Date(order.createdAt).toLocaleDateString('en-IN', {
                  day: 'numeric', month: 'long', year: 'numeric',
                })}
              </div>
            </div>
            <span className={`status-badge ${statusClassMap[order.status] || ''}`}>
              {order.status}
            </span>
          </div>

          <div style={{ marginBottom: 14 }}>
            {order.items.map((item, idx) => (
              <div key={idx} style={{
                fontSize: '0.88rem', color: 'var(--text-medium)', marginBottom: 4,
                display: 'flex', alignItems: 'center', gap: 6,
              }}>
                <span style={{ fontSize: '1rem' }}>🫙</span>
                <span>{item.productName}</span>
                <span style={{ color: 'var(--text-light)' }}>— {item.quantityKg} kg</span>
              </div>
            ))}
          </div>

          <div className="flex-between" style={{ flexWrap: 'wrap', gap: 10 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              <span style={{ fontWeight: 800, fontSize: '1.1rem', color: 'var(--primary)', letterSpacing: '-0.02em', fontFamily: 'Inter, sans-serif' }}>
                ₹{order.totalAmount}
              </span>
              <span className={`payment-chip ${paymentChipClass(order.paymentStatus)}`}>
                {order.paymentStatus}
              </span>
            </div>
            <div style={{ display: 'flex', gap: 8 }}>
              {order.status === 'Cancelled' ? (
                <span className="btn btn-secondary btn-sm" style={{ opacity: 0.4, cursor: 'not-allowed', pointerEvents: 'none' }}>
                  <FiEye /> Track Order
                </span>
              ) : (
                <Link to={`/orders/${order._id}`} className="btn btn-secondary btn-sm">
                  <FiEye /> Track Order
                </Link>
              )}
              <a
                href={order.status !== 'Cancelled' ? ordersAPI.getInvoiceUrl(order._id) : undefined}
                className="btn btn-sm"
                style={{ background: 'var(--text-heading)', color: 'white', ...(order.status === 'Cancelled' && { opacity: 0.4, cursor: 'not-allowed', pointerEvents: 'none' }) }}
                target="_blank"
                rel="noreferrer"
              >
                <FiDownload /> Invoice
              </a>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default OrdersPage;
